<section class="workspace" [class.workspace--dark]="darkMode()">
  <div class="workspace__shell">
    <app-navbar
      [appName]="'app.name' | translate"
      [moduleName]="'comparativeObject.moduleName' | translate"
      [moduleBadge]="'navbar.module2' | translate"
      logoutLink="/"
      [darkMode]="darkMode()"
      [language]="translationService.language()"
      [languages]="languages"
      (themeToggle)="toggleTheme()"
      (languageChange)="setLanguage($event)" />

    <main class="workspace__content">
      <section class="workspace__hero">
        <div class="workspace__hero-copy">
          <p class="workspace__eyebrow">{{ 'comparativeObject.eyebrow' | translate }}</p>
          <h1>{{ 'comparativeObject.title' | translate }}</h1>
          <p class="workspace__copy">
            {{ 'comparativeObject.copy' | translate }}
          </p>
        </div>
      </section>

      <section class="workspace__grid">
        <article class="panel panel--form">
          <div class="panel__toolbar">
            <span class="panel__tab panel__tab--active">{{ 'comparativeObject.form.panelLabel' | translate }}</span>
          </div>

          <form class="table-form" [formGroup]="form" (ngSubmit)="submit()" aria-label="Comparative object form">
            <div class="table-form__row">
              <label class="table-form__label" for="comparative-id">{{ 'comparativeObject.form.idLabel' | translate }}</label>
              <div class="table-form__value">
                <input id="comparative-id" type="text" formControlName="id"
                  [placeholder]="'comparativeObject.form.idPlaceholder' | translate"
                  [class.table-form__input--invalid]="hasError('id')" />
              </div>
            </div>
            @if (hasError('id')) {
              <small class="table-form__error">{{ 'comparativeObject.form.requiredMessage' | translate }}</small>
            }

            <div class="table-form__row">
              <label class="table-form__label" for="comparative-cadastral-area">{{ 'comparativeObject.form.cadastralAreaLabel' | translate }}</label>
              <div class="table-form__value">
                <input id="comparative-cadastral-area" type="text" formControlName="cadastralArea"
                  [placeholder]="'comparativeObject.form.cadastralAreaPlaceholder' | translate"
                  [class.table-form__input--invalid]="hasError('cadastralArea')" />
              </div>
            </div>
            @if (hasError('cadastralArea')) {
              <small class="table-form__error">{{ 'comparativeObject.form.requiredMessage' | translate }}</small>
            }

            <div class="table-form__row">
              <label class="table-form__label" for="comparative-parcel-number">{{ 'comparativeObject.form.parcelNumberLabel' | translate }}</label>
              <div class="table-form__value">
                <input id="comparative-parcel-number" type="text" formControlName="parcelNumber"
                  [placeholder]="'comparativeObject.form.parcelNumberPlaceholder' | translate"
                  [class.table-form__input--invalid]="hasError('parcelNumber')" />
              </div>
            </div>
            @if (hasError('parcelNumber')) {
              <small class="table-form__error">{{ 'comparativeObject.form.requiredMessage' | translate }}</small>
            }

            <div class="table-form__row">
              <label class="table-form__label" for="comparative-total-area">{{ 'comparativeObject.form.totalAreaLabel' | translate }}</label>
              <div class="table-form__value">
                <input id="comparative-total-area" type="number" formControlName="totalArea"
                  [placeholder]="'comparativeObject.form.totalAreaPlaceholder' | translate"
                  [class.table-form__input--invalid]="hasError('totalArea')" />
              </div>
            </div>
            @if (hasError('totalArea')) {
              <small class="table-form__error">{{ 'comparativeObject.form.requiredMessage' | translate }}</small>
            }

            <div class="table-form__row">
              <label class="table-form__label" for="comparative-realized-price">{{ 'comparativeObject.form.realizedPriceLabel' | translate }}</label>
              <div class="table-form__value">
                <input id="comparative-realized-price" type="number" formControlName="realizedPrice"
                  [placeholder]="'comparativeObject.form.realizedPricePlaceholder' | translate"
                  [class.table-form__input--invalid]="hasError('realizedPrice')" />
              </div>
            </div>
            @if (hasError('realizedPrice')) {
              <small class="table-form__error">{{ 'comparativeObject.form.requiredMessage' | translate }}</small>
            }

            <div class="table-form__row">
              <label class="table-form__label" for="comparative-date">{{ 'comparativeObject.form.dateLabel' | translate }}</label>
              <div class="table-form__value">
                <app-date-picker [inputId]="'comparative-date'" formControlName="date" [compact]="true"
                  [placeholder]="'comparativeObject.form.datePlaceholder' | translate"
                  [invalid]="hasError('date')" />
              </div>
            </div>
            @if (hasError('date')) {
              <small class="table-form__error">{{ 'comparativeObject.form.requiredMessage' | translate }}</small>
            }

            <div class="table-form__row">
              <label class="table-form__label" for="comparative-proceedings-number">{{ 'comparativeObject.form.proceedingsNumberLabel' | translate }}</label>
              <div class="table-form__value">
                <input id="comparative-proceedings-number" type="text" formControlName="proceedingsNumber"
                  [placeholder]="'comparativeObject.form.proceedingsNumberPlaceholder' | translate"
                  [class.table-form__input--invalid]="hasError('proceedingsNumber')" />
              </div>
            </div>
            @if (hasError('proceedingsNumber')) {
              <small class="table-form__error">{{ 'comparativeObject.form.requiredMessage' | translate }}</small>
            }

            <div class="table-form__row">
              <label class="table-form__label" for="comparative-zoning-category">{{ 'comparativeObject.form.zoningCategoryLabel' | translate }}</label>
              <div class="table-form__value">
                <input id="comparative-zoning-category" type="text" formControlName="zoningCategory"
                  [placeholder]="'comparativeObject.form.zoningCategoryPlaceholder' | translate"
                  [class.table-form__input--invalid]="hasError('zoningCategory')" />
              </div>
            </div>
            @if (hasError('zoningCategory')) {
              <small class="table-form__error">{{ 'comparativeObject.form.requiredMessage' | translate }}</small>
            }

            <div class="table-form__actions">
              <button type="submit" class="table-form__submit" [disabled]="isSubmitting">
                {{ isSubmitting ? ('comparativeObject.form.submitting' | translate) : ('comparativeObject.form.submit' | translate) }}
              </button>
            </div>

            @if (errorMessage) {
              <p class="form-status form-status--error">{{ errorMessage }}</p>
            }
          </form>
        </article>

        <section class="panel panel--output">
          <div class="panel__toolbar">
            <span class="panel__tab panel__tab--active">{{ 'comparativeObject.output.panelLabel' | translate }}</span>
            <button
              type="button"
              class="panel__action"
              (click)="exportToWord()"
              [disabled]="isExporting || !editableText.trim()">
              {{ isExporting ? ('comparativeObject.output.exporting' | translate) : ('comparativeObject.output.export' | translate) }}
            </button>
          </div>

          <div class="document-preview">
            <div class="document-preview__header">
              <span class="document-preview__dot"></span>
              <span class="document-preview__dot"></span>
              <span class="document-preview__dot"></span>
            </div>

            <textarea
              class="document-preview__editor"
              [(ngModel)]="editableText"
              [ngModelOptions]="{ standalone: true }"
              [placeholder]="'comparativeObject.output.placeholder' | translate"></textarea>

            @if (isSubmitting) {
              <p class="document-preview__status">{{ 'comparativeObject.output.loading' | translate }}</p>
            } @else if (!editableText.trim() && previewText()) {
              <pre>{{ previewText() }}</pre>
            }

            @if (exportErrorMessage) {
              <p class="form-status form-status--error">{{ exportErrorMessage }}</p>
            }
          </div>
        </section>
      </section>
    </main>

    <app-footer [darkMode]="darkMode()" />
  </div>
</section>
